import customersQueries from '@/api/modules/customersQueries'
import { t } from '@/i18n'
import { notificationService } from '@/services/notificationService'
import { handleApiError } from '@/utils/apiHelpers'

/**
 * CustomersService
 */
class CustomersService {
    async fetchCustomers(queryString = '') {
        try {
            return await customersQueries.fetchCustomers(queryString)
        } catch (error) {
            handleApiError(error, t('customers.notifications.fetchCustomersError'))
            throw error
        }
    }

    async fetchCustomerById(customerId) {
        try {
            return await customersQueries.fetchCustomerById(customerId)
        } catch (error) {
            handleApiError(error, t('customers.notifications.fetchCustomerDataError'))
            throw error
        }
    }

    async createCustomer(customerData) {
        try {
            const response = await customersQueries.createCustomer(customerData)
            notificationService.success(t('customers.notifications.customerCreated'))
            return response
        } catch (error) {
            handleApiError(error, t('customers.notifications.customerCreationError'))
            throw error
        }
    }

    async updateCustomer(customerData) {
        try {
            const response = await customersQueries.updateCustomer(customerData)
            notificationService.success(t('customers.notifications.customerUpdated'))
            return response
        } catch (error) {
            handleApiError(error, t('customers.notifications.customerUpdateError'))
            throw error
        }
    }

    async deleteCustomer(customerId) {
        try {
            const response = await customersQueries.deleteCustomer(customerId)
            notificationService.success(t('customers.notifications.customerDeleted'))
            return response
        } catch (error) {
            handleApiError(error, t('customers.notifications.customerDeleteError'))
            throw error
        }
    }

    async getCustomerAddresses(customerId) {
        try {
            return await customersQueries.getCustomerAddresses(customerId)
        } catch (error) {
            handleApiError(error, t('customers.notifications.fetchAddressesError'))
            throw error
        }
    }

    async getCustomerTypes() {
        try {
            return await customersQueries.getCustomerTypes()
        } catch (error) {
            handleApiError(error, t('customers.notifications.fetchCustomerTypesError'))
            throw error
        }
    }

    async getAddressTypes() {
        try {
            return await customersQueries.getAddressTypes()
        } catch (error) {
            handleApiError(error, t('customers.notifications.fetchAddressTypesError'))
            throw error
        }
    }

    async getCountries() {
        try {
            return await customersQueries.getCountries()
        } catch (error) {
            handleApiError(error, t('customers.notifications.fetchCountriesError'))
            throw error
        }
    }

    async getProductionFileCustomerConfiguration() {
        try {
            return await customersQueries.getProductionFileCustomerConfiguration()
        } catch (error) {
            handleApiError(error, t('customers.notifications.fetchFlowError'))
            throw error
        }
    }
}

export const useCustomersService = () => new CustomersService()
